import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { scrollIntoView } from "seamless-scroll-polyfill";

import { WINDOW } from "@hermes/app-core";

@Injectable()
export class ShopLocatorService {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window,
    ) {}

    public scrollToShowShop(
        hoveredShopId: number,
        shopIds: string[],
        isFull: boolean = false,
        idPrefix: string = "shop-item-",
        mapId: string = "shop-locator-map",
    ) {
        const uListElement = this.document.getElementById(
            `${idPrefix}${hoveredShopId}`,
        ) as HTMLUListElement;

        if (!uListElement) {
            return;
        }
        const mapElement = this.document.getElementById(mapId);
        if (!mapElement) {
            return;
        }
        uListElement.focus();
        if (shopIds.length === hoveredShopId + 1 && !isFull) {
            const mapPosition = mapElement.getBoundingClientRect();
            const uListPosition = uListElement.getBoundingClientRect();

            this.window.scrollBy({
                behavior: "smooth",
                top: uListPosition.bottom - mapPosition.bottom,
            });
        } else {
            scrollIntoView(uListElement, {
                behavior: "smooth",
                block: "center",
            });
        }
    }
}
